<template>
  <div class="setting-context">
    <div class="setting-main-header">
      <div class="main-header-left">
        <span>{{$t('staticSettings')}} ({{settingsData.glucose_unit}})</span>
      </div>
      <div class="main-header-right" >
        <button class="cancel" @click="cancel">{{$t('Cancel')}}</button>
        <button @click="apply">{{$t('save')}}</button>
      </div>
    </div>
    <hr class="small-hr">
    <div class="setting-main-context">
      <div class="item1 overflow" :class="{'it2':isIt,'po2':isPo,'es12':isEs||isFr}">
        <span class="alert-option" :class="{'it3':isIt,'po3':isPo,'du2':isDu,'de12':isDe,'es13':isEs||isSw,'fr13':isFr||isCz}">{{$t('showAlert')}}</span>
        <div class="alert-left" :class="{'alert-choose':alertOption}" @click="changeAlarm(0)">
          <p>{{$t('On')}}</p>
        </div>
        <div class="alert-right" :class="{'alert-choose':!alertOption}"  @click="changeAlarm(1)">
          <p>{{$t('Off')}}</p>
        </div>
      </div>
      <!-- <br/> -->
      <div class="item1 overflow" :class="{'it2':isIt,'po2':isPo,'es12':isEs||isFr}" v-if="true">
        <!-- TODO:添加国际化 -->
        <span class="alert-option" :class="{'it3':isIt,'po3':isPo,'du2':isDu,'de12':isDe,'es13':isEs||isSw,'fr13':isFr||isCz}">{{$t('t1215_Show_Glucose_Value')}}</span>
        <div class="alert-left" :class="{'alert-choose':glucoseOption}" @click="changeGlucose(0)">
          <p>{{$t('On')}}</p>
        </div>
        <div class="alert-right" :class="{'alert-choose':!glucoseOption}"  @click="changeGlucose(1)">
          <p>{{$t('Off')}}</p>
        </div>
      </div>
      <hr class="small-hr spe-hr">

      <p :class="{'zh9':!isEn ,'de9':isDe}">{{$t('glucoseTarget')}}</p>
      <hr class="small-hr spe-hr">

      <div class="item1">
        <div class="item-left">
          <span>{{$t('overall')}}</span><span>{{$t('Hypoglycemia')}}</span>
        </div>
        <div class="item-right" :class="{'zh10':!isEn,'it9':isIt,'po9':isPo}">
          <select v-model="settingsData.blos_low">
            <option v-for="i in sgLow">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high">
            <option v-for="i in sgHigh">{{i}}</option>
          </select>
          <span class="hyp" v-if="settingsData!=null">{{settingsData.hypo}}</span>
        </div>
      </div>

      <hr class="small-hr spe-hr">
      <div class="titleLabl">
        <p class="spe-label" :class="{'zh6':!isEn,'de6':isDe}">{{$t('glucoseTarget')}}</p>
        <p :class="{'zh7':!isEn,'es7':isEs,'de7':isDe,'it7':isIt,'po7':isPo||isFr,'sw7':isSw}">{{$t('timePeriod')}}</p>
        <p class="spe1-label1" :class="{'zh8':!isEn,'es8':isEs,'de8':isDe,'po8':isPo||isFr,'sw8':isSw||isCz}">{{$t('postMeal')}}</p>
      </div>
      <hr class="small-hr spe-hr">
      <div class="titleLab2">
        <span class="spe-labe2" :class="{'zh4':!isEn,'es4':isEs,'de4':isDe,'it4':isIt,'du4':isDu}">{{$t('Low')}}</span> <span>{{$t('High')}}</span>
        <span class="largeSpace" :class="{'it6':isIt,'po6':isPo}">{{$t('From')}}</span><span :class="{'fr6':isFr}">{{$t('To')}}</span>
        <span class="largeSpace1" :class="{'zh5':!isEn,'es5':isEs,'it6':isIt,'po5':isPo,'fr7':isFr}">{{$t('From')}}</span><span>{{$t('To')}}</span>
      </div>

      <div class="item1">
        <div class="item1-1">
          <span>{{$t('Breakfast')}}</span>
        </div>
        <div class="item1-2" :class="{'zh1':!isEn,'de2':isDe,'du3':isDu,'fr3':isFr,'sw3':isSw}">
          <span>{{$t('Before')}}</span>
          <span>{{$t('After')}}</span>
        </div>
        <div class="item1-3">
          <select v-model="settingsData.blos_low_before_b">
            <option v-for="i in sgLow">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high_before_b">
            <option v-for="i in sgHigh">{{i}}</option>
          </select>

          <select v-model="settingsData.blos_low_after_b">
            <option v-for="i in sgLowAfter">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high_after_b">
            <option v-for="i in sgHighAfter">{{i}}</option>
          </select>
        </div>
        <div class="item1-4 Setting-time">
          <el-time-select v-model="settingsData.btime1_s " size="mini" :clearable=false :editable=false
            :picker-options="{ start: '06:00',step: '00:15', end: '10:00' }" placeholder="Time">
          </el-time-select>
          <hr class="tiny-hr">
          <el-time-select v-model="settingsData.btime1_e " size="mini"  placeholder="Time" :clearable=false :editable=false
                          :picker-options="{ start: '06:00',step: '00:15', end: '10:00',minTime:settingsData.btime1_s }">
          </el-time-select>
        </div>
        <div class="item1-5 Setting-time">
          <el-time-select v-model="settingsData.afterb_s " size="mini" placeholder="Time" :clearable=false :editable=false
                          :picker-options="{ start: '00:30',step: '00:15', end: '2:00' }" >
          </el-time-select>
          <hr class="tiny-hr">
          <el-time-select v-model="settingsData.afterb_e " size="mini" placeholder="Time" :clearable=false  :editable=false
                          :picker-options="{ start: '01:00',step: '00:15', end: '4:00',minTime:settingsData.afterb_s }" >
          </el-time-select>
        </div>
        <span class="hours">{{$t('Hours')}}</span>
      </div>
      <hr class="small-hr spe-hr">

      <div class="item1">
        <div class="item1-1">
          <span>{{$t('Lunch')}}</span>
        </div>
        <div class="item1-2" :class="{'zh1':!isEn,'de2':isDe,'du3':isDu,'fr3':isFr,'sw3':isSw}">
          <span>{{$t('Before')}}</span>
          <span>{{$t('After')}}</span>
        </div>
        <div class="item1-3">
          <select v-model="settingsData.blos_low_before_l">
            <option v-for="i in sgLow">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high_before_l">
            <option v-for="i in sgHigh">{{i}}</option>
          </select>
          <select v-model="settingsData.blos_low_after_l">
            <option v-for="i in sgLowAfter">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high_after_l">
            <option v-for="i in sgHighAfter">{{i}}</option>
          </select>
        </div>
        <div class="item1-4 Setting-time">
          <el-time-select v-model="settingsData.ltime1_s " size="mini" :clearable=false :editable=false
                          :picker-options="{ start: '11:00',step: '00:15', end: '15:00' }" placeholder="Time">
          </el-time-select>
          <hr class="tiny-hr">
          <el-time-select v-model="settingsData.ltime1_e " size="mini"  placeholder="Time" :clearable=false :editable=false
                          :picker-options="{ start: '11:00',step: '00:15', end: '15:00',minTime:settingsData.ltime1_s}">
          </el-time-select>
        </div>
        <div class="item1-5 Setting-time">
          <el-time-select v-model="settingsData.afterl_s " size="mini" :clearable=false :editable=false
                          :picker-options="{ start: '00:30',step: '00:15', end: '2:00' }" placeholder="Time">
          </el-time-select>
          <hr class="tiny-hr">
          <el-time-select v-model="settingsData.afterl_e " size="mini" placeholder="Time" :clearable=false :editable=false
                          :picker-options="{ start: '1:00',step: '00:15', end: '4:00',minTime:settingsData.afterl_s}">
          </el-time-select>
        </div>
        <span class="hours">{{$t('Hours')}}</span>
      </div>
      <hr class="small-hr spe-hr">

      <div class="item1">
        <div class="item1-1">
          <span>{{$t('Dinner')}}</span>
        </div>
        <div class="item1-2" :class="{'zh1':!isEn,'de2':isDe,'du3':isDu,'fr3':isFr,'sw3':isSw}">
          <span>{{$t('Before')}}</span>
          <span>{{$t('After')}}</span>
        </div>
        <div class="item1-3">
          <select v-model="settingsData.blos_low_before_s">
            <option v-for="i in sgLow">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high_before_s">
            <option v-for="i in sgHigh">{{i}}</option>
          </select>
          <select v-model="settingsData.blos_low_after_s">
            <option v-for="i in sgLowAfter">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high_after_s">
            <option v-for="i in sgHighAfter">{{i}}</option>
          </select>
        </div>
        <div class="item1-4 Setting-time">
          <el-time-select v-model="settingsData.stime1_s " size="mini" :clearable=false :editable=false
                          :picker-options="{ start: '17:00',step: '00:15', end: '21:00' }" placeholder="Time">
          </el-time-select>
          <hr class="tiny-hr">
          <el-time-select v-model="settingsData.stime1_e " size="mini" placeholder="Time" :clearable=false :editable=false
                          :picker-options="{ start: '17:00',step: '00:15', end: '21:00',minTime:settingsData.stime1_s }">
          </el-time-select>
        </div>
        <div class="item1-5 Setting-time">
          <el-time-select v-model="settingsData.afters_s " size="mini" :clearable=false :editable=false
                          :picker-options="{ start: '00:30',step: '00:15', end: '2:00' }" placeholder="Time">
          </el-time-select>
          <hr class="tiny-hr">
          <el-time-select v-model="settingsData.afters_e " size="mini" placeholder="Time" :clearable=false :editable=false
                          :picker-options="{ start: '1:00',step: '00:15', end: '4:00',minTime:settingsData.afters_s }">
          </el-time-select>
        </div>
        <span class="hours">{{$t('Hours')}}</span>
      </div>
      <hr class="small-hr spe-hr">

      <div class="item1">
        <div class="item1-1">
          <span class="night" :class="{'es3':isEs}">{{$t('night')}}</span>
        </div>
        <div class="item1-3 spe-ietm" :class="{'zh2':!isEn,'es2':isEs}">
          <select v-model="settingsData.blos_low_night">
            <option v-for="i in sgLow">{{i}}</option>
          </select>
          <hr class="tiny-hr">
          <select v-model="settingsData.blos_high_night">
            <option v-for="i in sgHigh">{{i}}</option>
          </select>
        </div>
        <div class="item1-4 Setting-time">
          <el-time-select v-model="settingsData.etime1_s  " size="mini" :clearable=false :editable=false
                          :picker-options="{ start: '22:00',step: '00:15', end: '24:00' }" placeholder="Time">
          </el-time-select>
          <hr class="tiny-hr">
          <el-time-select v-model="settingsData.etime1_e  " size="mini" :clearable=false :editable=false
                          :picker-options="{ start: '05:00',step: '00:15', end: '07:00' }" placeholder="Time">
          </el-time-select>
        </div>
      </div>
    </div>
    <hr class="small-hr spe-hr">
    <div class="setting-operate2">
      <button @click = "restore" class="reset" :class="{'es1':isEs,'de1':isDe,'it1':isIt||isCz,'po1':isPo,'du1':isDu}">{{$t('Reset')}}</button>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default{
    data(){
      return{
        uid:0,isEn:false,isMg:'',isEs:false,isDe:false,isIt:false,isPo:false,isDu:false,isFr:false,isSw:false,isCz:false,
      }
    },
    computed:{
      settingsData(){
          return this.$store.state.settingData;
      },
      sgLow(){
        let low =[];
        if( this.isMg){
          for(let i=60;i<101;i=i+1){
            low.push(i.toFixed(0));
          }
        }else{
          for(let i=2.8;i<5.6;i=i+0.1){
            low.push(i.toFixed(1));
          }
        }
        return low;
      },
      sgHigh(){
        let high =[];
        if( this.isMg){
          for(let i=100;i<361;i=i+1){
            high.push(i.toFixed(0));
          }
        }else{
          for(let i=5.6;i<20.1;i=i+0.1){
            high.push(i.toFixed(1));
          }
        }
        return high;
      },
      sgLowAfter(){
        let low =[];
        if( this.isMg){
          for(let i=60;i<131;i=i+1){
            low.push(i.toFixed(0));
          }
        }else {
          for (let i = 3.3; i < 7.2; i = i + 0.1) {
            low.push(i.toFixed(1));
          }
        }
        return low;
      },
      sgHighAfter(){
        let high =[];
        if( this.isMg){
          for(let i=130;i<361;i=i+1){
            high.push(i.toFixed(0));
          }
        }else {
          for (let i = 7.2; i < 20.1; i = i + 0.1) {
            high.push(i.toFixed(1));
          }
        }
        return high;
      },
      alertOption(){
        let option = this.$store.state.alarm_display;
        return (option==='On')?true:false;
      },
      glucoseOption(){
        let option = this.$store.state.glucose_display;
        return (option==='On')?true:false;
      },
    },
    methods:{
      apply(){
        if(sessionStorage.getItem('userType')!=='P'){
          this.uid = parseInt(sessionStorage.getItem('patientId'));
        }else{
          this.uid = parseInt(sessionStorage.getItem('uid'));
        }
        let flag =  this.isMg;
        let settings = {
            glucose_unit:'mmol/L',
            btime1_s:this.settingsData.btime1_s,
            btime1_e:this.settingsData.btime1_e,
            afterb_s:this.settingsData.afterb_s,
            afterb_e:this.settingsData.afterb_e,
            blos_low_before_b:flag?parseFloat(this.settingsData.blos_low_before_b/18):parseFloat(this.settingsData.blos_low_before_b),
            blos_high_before_b:flag?parseFloat(this.settingsData.blos_high_before_b/18):parseFloat(this.settingsData.blos_high_before_b),
            blos_low_after_b:flag?parseFloat(this.settingsData.blos_low_after_b/18):parseFloat(this.settingsData.blos_low_after_b),
            blos_high_after_b:flag?parseFloat(this.settingsData.blos_high_after_b/18):parseFloat(this.settingsData.blos_high_after_b),
            ltime1_s:this.settingsData.ltime1_s,
            ltime1_e:this.settingsData.ltime1_e,
            afterl_s:this.settingsData.afterl_s,
            afterl_e:this.settingsData.afterl_e,
            blos_low_before_l:flag?parseFloat(this.settingsData.blos_low_before_l/18):parseFloat(this.settingsData.blos_low_before_l),
            blos_high_before_l:flag?parseFloat(this.settingsData.blos_high_before_l/18):parseFloat(this.settingsData.blos_high_before_l),
            blos_low_after_l:flag?parseFloat(this.settingsData.blos_low_after_l/18):parseFloat(this.settingsData.blos_low_after_l),
            blos_high_after_l:flag?parseFloat(this.settingsData.blos_high_after_l/18):parseFloat(this.settingsData.blos_high_after_l),
            stime1_s:this.settingsData.stime1_s,
            stime1_e:this.settingsData.stime1_e,
            afters_s:this.settingsData.afters_s,
            afters_e:this.settingsData.afters_e,
            blos_low_before_s:flag?parseFloat(this.settingsData.blos_low_before_s/18):parseFloat(this.settingsData.blos_low_before_s),
            blos_high_before_s:flag?parseFloat(this.settingsData.blos_high_before_s/18):parseFloat(this.settingsData.blos_high_before_s),
            blos_low_after_s:flag?parseFloat(this.settingsData.blos_low_after_s/18):parseFloat(this.settingsData.blos_low_after_s),
            blos_high_after_s:flag?parseFloat(this.settingsData.blos_high_after_s/18):parseFloat(this.settingsData.blos_high_after_s),
            etime1_s:this.settingsData.etime1_s,
            etime1_e:this.settingsData.etime1_e,
            blos_low_night:flag?parseFloat(this.settingsData.blos_low_night/18):parseFloat(this.settingsData.blos_low_night),
            blos_high_night:flag?parseFloat(this.settingsData.blos_high_night/18):parseFloat(this.settingsData.blos_high_night),
            blos_low:flag?parseFloat(this.settingsData.blos_low/18):parseFloat(this.settingsData.blos_low),
            blos_high:flag?parseFloat(this.settingsData.blos_high/18):parseFloat(this.settingsData.blos_high),
            hypo :flag?parseFloat(this.settingsData.hypo/18):parseFloat(this.settingsData.hypo),
            alarm_display:(this.alertOption)?"On":"Off",
            glucose_display:(this.glucoseOption)?"On":"Off",
          };
        this.$http.post('api/v2.0/settings/'+this.uid,{settings:settings}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let tip = this.$t('saveTip');
            this.$message({
              type: 'success',
              message:tip
            });
            auth.getSettingData(this,this.uid);
          }else{
            let tip =this.$t('Input error');
            this.$message.error(tip);
          }
        });
      },
      cancel(){
        this.$router.push('/monitor')
      },
      restore(){
        let flag = this.isMg;
        let settings = {
          glucose_unit:"mmol/L",
          btime1_s:'7:00',
          btime1_e:"8:00",
          afterb_s:'1:00',
          afterb_e:'3:00',
          blos_low_before_b:(flag)?70:3.9,
          blos_high_before_b:(flag)?130:7.2,
          blos_low_after_b:(flag)?100:5.6,
          blos_high_after_b:(flag)?Math.round(8.9*18):8.9,
          ltime1_s:'12:00',
          ltime1_e:'13:00',
          afterl_s:'1:00',
          afterl_e:'3:00',
          blos_low_before_l:(flag)?70:3.9,
          blos_high_before_l:(flag)?130:7.2,
          blos_low_after_l:(flag)?100:5.6,
          blos_high_after_l:(flag)?160:8.9,
          stime1_s:'18:00',
          stime1_e:'19:00',
          afters_s:'1:00',
          afters_e:'3:00',
          blos_low_before_s:(flag)?70:3.9,
          blos_high_before_s:(flag)?130:7.2,
          blos_low_after_s:(flag)?100:5.6,
          blos_high_after_s:(flag)?160:8.9,
          etime1_s:'23:00',
          etime1_e:'6:00',
          blos_low_night:(flag)?100:5.6,
          blos_high_night:(flag)?160:8.9,
          blos_low:(flag)?70:3.9,
          blos_high:(flag)?180:'10.0',
          hypo :(flag)?56:3.1 ,
        };
        this.$store.commit('updateAlarm','Off');
        this.$store.commit('updateSettingData',settings);
      },
      changeAlarm(flag){
        let alarm_display =(flag===0)?'On':'Off';
        this.$store.commit('updateAlarm', alarm_display);
      },
      changeGlucose(flag){
        let glucose_display =(flag===0)?'On':'Off';
        this.$store.commit('updateGlucose', glucose_display);
      }
    },
    mounted(){
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isEs = (lang==='es')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isSw = (lang==='sw')?true:false;
      this.isCz = (lang==='cz')?true:false;
    },
  }
</script>

<style scoped>
  .setting-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    height:30px;
    line-height: 30px;
  }

  .setting-main-context{
    width:100%;
    height:550px;
    font-family:SFUIText-Regular;
    font-size:18px;
    letter-spacing:-0.44px;
  }
  .setting-main-context p{
    color:#0082d2;
    text-align:left;
    margin-left:23%;
  }
  .setting-main-context .zh9{
    margin-left:265px;
  }
  .setting-main-context .de9{
    margin-left:215px;
  }
  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    width:90%;
    clear: both;
  }
  .item1{
    width:90%;
    margin:0 auto;
  }
  .overflow {
    overflow: hidden;
    display: flex;
  }
  .item1 span{
    color:#282828;
    display: block;
    height:22px;
    line-height: 22px;
    margin-bottom: 20px;
    flex: 0 0 20%;
  }
  .alert-option{
    float: left;
    margin-right: 3%;
  }
  .alert-left,.alert-right{
    width: 60px;
    float: left;
    height: 25px;
    line-height: 25px;
    cursor: pointer;
    color: #0090ff;
    border: 1px solid #0090ff;
  }
  .alert-left{
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }
  .alert-right{
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }
  .alert-choose{
    background-color:  #0090ff;
  }
  .alert-choose p{
    color:#fff;
  }
  .it2 div{
    width: 75px;
  }
  .it2 p{
    margin-left: 10px;
  }
  .it3{
    margin-right:10%;
  }
  .po2 div{
    width: 90px;
    text-align: center;
  }
  .po2 .alert-left p{
    margin-left:20px;
  }
  .po2 .alert-right p{
    margin-left:10px;
  }
  .po3{
    margin-right:9%;
  }
  .du2{
    margin-right:3%;
  }
  .de12{
    margin-right:3%;
  }
  .es12 div{
    width: 93px;
    text-align: center;
  }
  .es12 .alert-left p{
    margin-left:20px;
  }
  .es12 .alert-right p{
    margin-left:10px;
  }
  .es13{
    margin-right:9%;
  }
  .fr13{
    margin-right:6%;
  }

  .item-left{
    float: left;
  }
  .item-right{
    float: left;
    margin-left: 9%;
  }
  .it9{
    margin-left: 10%;
  }
  .zh10{
    margin-left: 75px;
  }
  .po9{
    margin-left: 10%;
  }
  select{
    background:#ffffff;
    border:1px solid #d2d2d2;
    border-radius:4px;
    width:68px;
    height:25px;
    font-size:16px;
    margin-bottom: 18px;
    float: left;
    padding-left: 6px;
  }
  .tiny-hr{
    border:1px solid #a68261;
    background: #a68261;
    width:8px;
    height:1px;
    float: left;
    opacity: 0.8;
    margin:10px 8px;
  }
  .item-right span{
    margin-left:20px;
  }
  .hyp{
    clear: both;
  }
  .titleLabl{
    width:100%;
    margin-bottom: 12px;
    height:20px;
  }
  .titleLabl p{
    float: left;
    margin-left:75px;
  }
  .titleLabl .spe-label{
    margin-left:250px;
  }
  .titleLabl .zh6{
    margin-left:265px;
  }
  .titleLabl .de6{
    margin-left:215px;
  }
  .titleLabl .zh7{
    margin-left:140px;
  }
  .titleLabl .es7{
    margin-left:50px;
  }
  .titleLabl .de7{
    margin-left:50px;
  }
  .titleLabl .po7{
    margin-left:50px;
  }
  .titleLabl .it7{
    margin-left:112px;
  }
  .titleLabl .spe1-label1{
    margin-left: 120px;
  }
  .titleLabl .zh8{
    margin-left:150px;
  }
  .titleLabl .es8{
    margin-left:55px;
  }
  .titleLabl .de8{
    margin-left:90px;
  }
  .titleLabl .po8{
    margin-left:65px;
  }
  .titleLabl .sw7{
    margin-left:60px;
  }
  .titleLabl .sw8{
    margin-left:105px;
  }
  .titleLab2{
    margin:0 auto 10px;
    width:100%;
    height:18px;
  }
  .titleLab2 span{
    margin-right:50px;
  }
  .titleLab2 .spe-labe2{
    margin-left: 270px;
  }
  .titleLab2 .zh4{
    margin-left: 255px;
  }
  .titleLab2 .es4{
    margin-left: 280px;
    margin-right: 55px;
  }
  .titleLab2 .de4{
    margin-left: 247px;
    margin-right: 55px;
  }
  .titleLab2 .it4{
    margin-left: 255px;
    margin-right: 55px;
  }
  .titleLab2 .du4{
    margin-left: 260px;
    margin-right: 55px;
  }
  .titleLab2 .largeSpace{
    margin-left: 30px;
    margin-right:70px;
  }
  .titleLab2 .largeSpace1{
    margin-left: 40px;
    margin-right: 60px;
  }
  .titleLab2 .it6{
    margin-right: 85px;
  }
  .titleLab2 .po6{
    margin-right: 82px;
  }
  .titleLab2 .zh5{
    margin-left: 20px;
    margin-right: 70px;
  }
  .titleLab2 .es5{
    margin-left: 0;
    margin-right: 50px;
  }
  .titleLab2 .po5{
    margin-left: 25px;
    margin-right: 80px;
  }
  .titleLab2 .fr6{
    margin-left: 25px;
    margin-right: 50px;
  }
  .titleLab2 .fr7{
    margin-right: 75px;
  }
  .item1-1,.item1-2{
    float: left;
    margin-right: 37px;
  }
  .de2{
    margin-right: 43px;
  }
  .du3{
    margin-right: 50px;
  }
  .fr3{
    margin-right: 45px;
  }
  .sw3{
    margin-right: 53px;
  }

  .item1-1{
    width:70px;
  }
  .item1-1 .night{
    width: 100px;
  }
  .item1-1 .es3{
    width: 120px;
  }
  .zh1{
    margin-right: 57px;
  }
  .item1-3,.item1-4{
    float: left;
    margin-right: 25px;
    width:180px;
  }
  .item1-5{
    float: left;
  }
  .Setting-time{
    width:190px;
  }
  .Setting-time select{
    width: 80px;
  }
  .hours{
    float: left;
    margin-left:5px;
  }
  .spe-ietm{
    margin-left: 84px;
  }
  .zh2{
    margin-left: 75px;
  }
  .es2{
    margin-left: 100px;
  }
  .el-date-editor.el-input{
    float: left;
    width: 80px;
    padding-left: 0;
  }

  .setting-operate2{
    margin-top: 70px;
  }
   button{
    float: right;
    background:#fff;
    color:#282828;
    border: 1px solid #a3a3a3;
    outline: none;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    font-size:16px;
    height:30px;
    line-height: 30px;
    letter-spacing:-0.39px;
    text-align:center;
    margin-right:2%;
    margin-bottom: 20px;
    width: 135px;
    cursor: pointer;
  }
  .reset{
    width: 180px;
    margin-right:4%;
  }
  .es1{
    width: 220px;
  }
  .de1{
    width: 290px;
  }
  .it1{
    width: 230px;
  }
  .po1{
    width: 300px;
  }
  .du1{
    width: 250px;
  }

  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#ffffff;
  }
  .cancel{
    width: 135px;
  }
  @media screen and (max-width: 1500px){
    .titleLab2 .spe-labe2{
      margin-left: 265px;
    }
  }

</style>



// WEBPACK FOOTER //
// setting.vue?53772498